'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OK = exports.OK = 200;
var NO_CONTENT = exports.NO_CONTENT = 204;
var GONE = exports.GONE = 410;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/HttpStatusCodes.js
// module id = 607
// module chunks = 2 3